module.exports = __webpack_public_path__ + "2fb940bfbc068317009ea7e212a7abac.png";